import React, { useState, useEffect } from 'react'
import axios from "axios";
import AdminSidebar from './AdminSidebar'
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const AdminPanel = () => {
    const [counts, setCounts] = useState(null)
    useEffect(() => {
        axios.get(SERVER_URL+"/api/admin/get-count/",
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization:
                        "Bearer " +
                        JSON.parse(localStorage.getItem("userTokenTime")).token,
                }
            }
        ).then((res) => {
            setCounts(res.data);
        });
    }, []);


    return (
        <div className='panel__container'>
            <AdminSidebar activeTab={1} />
            <div style={{ width: "87.5%", padding: "20px", marginLeft: "12.5%" }}>
                <div className='outer__container'>
                    <div className='inner__container1'>
                        <div>
                            <div className="admin__icon p-2 cursor-pointer rounded-full">
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z">
                                    </path>
                                </svg>
                            </div>
                            <h5>Customers</h5>
                            <div className="perc items-center space-x-1 text-green-500">
                                <span>{counts && counts.userCount}</span>
                                <span>
                                    <svg className="percsvg" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="admin__icon p-2 cursor-pointer rounded-full" style={{ backgroundColor: "#FED7D7" }}>
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01">
                                    </path>
                                </svg>
                            </div>

                            <h5>Orders</h5>
                            <div className="perc items-center space-x-1 text-green-500"  >
                                <span>{counts && counts.orderCount}</span>
                                <span>
                                    <svg className="percsvg" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className="admin__icon p-2 cursor-pointer rounded-full" style={{ backgroundColor: "#C6F6D5" }}  >
                                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </div>


                            <h5>Products</h5>
                            <div className="perc items-center space-x-1 text-green-500">
                                <span>{counts && counts.productCount}</span>
                                <span>
                                    <svg className="percsvg" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div>

                            <div className="admin__icon p-2 cursor-pointer rounded-full" style={{ backgroundColor: "#FEEBC8" }}>
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z">
                                    </path>
                                </svg>
                            </div>
                            <h5>Categories</h5>
                            <div className="perc items-center space-x-1 text-green-500">
                                <span>{counts && counts.categoryCount}</span>
                                <span>
                                    <svg className="percsvg" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style={{ height: "50px" }}></div>
                    <div className='inner__container2'>
                        <h3>Recent Orders {counts && counts.orderCount}</h3>

                        <div style={{ height: "10px" }}></div>

                        <table className="orders-table border w-full my-2">
                            <thead>
                                <tr>
                                    <th className="px-4 py-2 border">Products</th>
                                    <th className="px-4 py-2 border">Image</th>
                                    <th className="px-4 py-2 border">Status</th>
                                    <th className="px-4 py-2 border">Order Address</th>
                                    <th className="px-4 py-2 border">Ordered at</th>
                                </tr>
                                <tr>
                                    <td
                                        colSpan="10"
                                        className="text-xl text-center font-semibold py-8"
                                        style={{ padding: "2rem", textAlign: "center", fontWeight: "500", fontSize: "x-large" }}
                                    >
                                        No orders found
                                    </td>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>


                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminPanel